export enum WageAndTravelStatus {    
    PendingProfile                = 1,
    PendingAdvancedReimbursement  = 2,
    PendingDocuments              = 5,
    PendingNkrVerifyTax           = 10,
    PendingNkrVerifyStub          = 11,
    PendingNkrVerifyAmount        = 12,
    PendingSurgery                = 15,
    PendingWageReimbursement      = 20,
    PendingTravelReceipts         = 25,
    PendingNkrVerifyTravel        = 30,
    PendingTravelReimbursement    = 35,
    Donated                       = 100,
    Denied                        = 200,
    Expired                       = 210,
    RequestCancelled              = 220,
}